import epcProjectService from '../../../../services/epcProjectService';

export type ScheduleExportFormat = 'mpp' | 'xml';

/**
 * Download the schedule export for MS Project and report which format the
 * backend delivered: true binary .mpp when the converter holds an Aspose
 * license, MSPDI .xml fallback (opens natively in MS Project — Save As .mpp
 * from there) while it does not. Format is detected from the response blob's
 * content type.
 */
export async function downloadScheduleExport(
  projectId: string,
  baseName: string
): Promise<{ format: ScheduleExportFormat }> {
  const blob = await epcProjectService.exportScheduleMppBlob(projectId);
  const format: ScheduleExportFormat = blob.type.includes('xml') ? 'xml' : 'mpp';
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${baseName}.${format}`;
  a.click();
  URL.revokeObjectURL(a.href);
  return { format };
}
